<template>
    <v-dialog v-model="dialog" content-class="fullscreen-image" style="z-index: 2600">
        <v-icon color="gray"
                @click="closeDialog()"
                class="close-btn"
                large>close</v-icon>
        <div>
            <v-img contain
                   :src="(currentMedia.url !== undefined && currentMedia.url !== null) ? currentMedia.url : currentMedia.origin_url"
                   :lazy-src="currentMedia.thumbnail_url" class="ml-auto" max-height="100vh" max-width="100vw">
            </v-img>
        </div>
    </v-dialog>
</template>

<script>
import {mapMutations, mapState} from "vuex"
export default {
    name: "MediaFullScreenModal",
    methods: {
        ...mapMutations('web_form', ['setMediaFullScreenDialog']),
        closeDialog() {
            this.setMediaFullScreenDialog(false)
        }
    },
    computed: {
        ...mapState("web_form", ['mediaFullScreenDialog', 'currentMedia']),
        dialog :{
            get () {
                return this.mediaFullScreenDialog
            },
            set (value) {
                this.setMediaFullScreenDialog(value)
            }
        }
    }
}
</script>
